import { Dropdown } from 'react-bootstrap'
import { userCurrentUser } from '@/features/apiSliceWithCurrentUser'
import { getCSRFToken } from '@/utils/requests'

export default function UserMenu() {
  const currentUser = userCurrentUser()

  const initials = (() => {
    const f = currentUser?.firstName?.trim?.()
    const l = currentUser?.lastName?.trim?.()
    if (f || l) {
      return `${(f?.[0] || '')}${(l?.[0] || '')}`.toUpperCase() || (currentUser as any)?.email?.[0]?.toUpperCase() || '?'
    }
    const email = (currentUser?.email || '')
    return email?.[0]?.toUpperCase() || '?'
  })()

  // Sign-out handler for Devise
  const handleSignOut = async () => {
    await fetch('/users/sign_out', {
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': getCSRFToken() || '',
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      credentials: 'same-origin',
    })
    window.location.href = '/' // Redirect after sign out
  }

  const handleSingIn = () => window.location.href = '/users/sign_in'

  return (
    <Dropdown align="end" className="px-2">
      <Dropdown.Toggle
        as="div"
        bsPrefix="no-caret"
        className="rounded-circle p-0 border-0 bg-primary text-white d-flex align-items-center justify-content-center"
        style={{ width: 40, height: 40, cursor: 'pointer' }}
        aria-label="User menu"
      >
        <span className="fw-semibold" style={{ lineHeight: 1 }}>{initials}</span>
      </Dropdown.Toggle>
      <Dropdown.Menu align="end">
        <Dropdown.Header className="text-truncate" style={{ maxWidth: 260 }}>
          {(currentUser as any)?.email || '—'}
        </Dropdown.Header>
        <Dropdown.Divider />
        <Dropdown.Item
          onClick={currentUser ? handleSignOut : handleSingIn}
          className="text-primary"
        >
          {`Sign ${currentUser ? 'out' : 'in'}`}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}
